export const POSTHOG_EVENTS = {
  ADMIN_INTEGRATION_PLATFORM_UPDATED:
    'admin_integration_platform_updated',
  TEMPLATES_TAB_VISIBILITY_UPDATED:
    'templates_tab_visibility_updated',
  TEMPLATES_TAB_CLICKED: 'templates_tab_clicked',
} as const;
